<template>
  <a-upload
    :name="name"
    :accept="accept"
    :multiple="false"
    :headers="headers"
    :action="uploadAction"
    @change="handleFileChange"
    :file-list="fileUrlList"
    :remove="handleRemove"
  >
    <a-button><a-icon type="link" />选择文件</a-button>
  </a-upload>
</template>
<script>
import Vue from 'vue';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { postAction } from '@/api/manage';
export default {
  props: {
    accept: {
      type: String,
      default: '.zip, .doc, .docx, .pdf',
    },
    name: {
      type: String,
      default: 'file',
    },
    fileList: {
      type: Array,
      default: [],
    },
    deleteUrl: {
      type: String,
      default: '',
    },
    num: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      headers: { 'X-Access-Token': Vue.ls.get(ACCESS_TOKEN) },
      uploadAction: '',
      fileUrlList: [],
    };
  },
  // watch: {
  //   fileList() {
  //     console.log(1111);
  //     this.initFileList();
  //   },
  // },
  created() {
    let host =
      window.location.hostname == 'localhost'
        ? process.env.VUE_APP_LOCAL_PATH +
          process.env.VUE_APP_GATEWAY_URL +
          'system-file-biz/resources/upload'
        : process.env.VUE_APP_GATEWAY_URL + 'system-file-biz/resources/upload';
    this.uploadAction = host;
    this.initFileList(this.fileList);
  },
  methods: {
    initFileList(list) {
      let _that = this;
      if (list && list.length > 0) {
        list.forEach((item) => {
          let obj = {
            name: item.attachmentName,
            url: item.previewUrl,
            uid: item.id,
            createdTime: item.createTime,
          };
          _that.fileUrlList.push(obj);
        });
        console.log('********', _that.fileUrlList);
      } else {
        _that.fileUrlList = [];
      }
    },
    //文件上传
    handleFileChange(info) {
      const { file, fileList } = info;
      let status = file.status;

      if (status == 'done') {
        let res = file.response;
        if (res.success) {
          this.$message.success('上传成功！');
          let index = this.fileUrlList.findIndex(
            (item) => item.name == file.name
          );

          let attachmentList = [];
          let fileObj = {
            uid: file.uid,
            name: file.name,
            createdTime: file.lastModifiedDate,
            size: file.size,
            fileName: res.result.fileName,
            url: res.result.fileName, //res.result.
          };
          attachmentList.push(fileObj);
          index != -1 && this.fileUrlList.splice(index, 1);
          if (this.num == 1) {
            this.fileUrlList = attachmentList;
          } else {
            //当前上传的数量
            this.fileUrlList = this.fileUrlList.concat(attachmentList); //this.attachmentList;
          }

          this.$emit('handleFileList', this.fileUrlList);
        } else {
          this.fileUrlList = [];
        }
      } else {
        this.fileUrlList = [...fileList];
      }
    },
    //文件删除
    handleRemove(val) {
      let _that = this;
      postAction(_that.deleteUrl, { id: val.uid }).then((res) => {
        if (res.code == 0) {
          _that.$emit('handleFileList', _that.fileUrlList);
          _that.$message.success('删除成功');
        } else {
          _that.$message.error(res.message);
        }
      });
    },
  },
};
</script>
